/* GASSISA
=========================================================================================
* Descripcion: Menu de acciones exclusivo para preventas portatil.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion con buscador local portatil
* ---------------------------------------------------------------------------------------
*/

import { Fragment } from "react";
import { IconButton, Tooltip } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import VerifiedIcon from "@mui/icons-material/Verified";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import DensitySmallIcon from "@mui/icons-material/DensitySmall";
import { useVentas } from "../../../context/Ventas/VentasContext";
import { useDoubleClickPrevention } from "../../../hooks/useDoubleClickPrevention";

export default function MnuPreVentasActionsPortatil({ onBuscarArticulos }) {
  const { isProcessing, executeWithProtection } = useDoubleClickPrevention();
  const {
    handleClickRegresarMainDashboard,
    handleClickRefrescarDatosPreVenta,
    handleArirModalFirmaPreVenta,
    handleArirModalBuscarCliente,
    handleAbrirMenuModalPreventa,
  } = useVentas();

  return (
    <Fragment>
      <Tooltip title="Salir">
        <IconButton onClick={handleClickRegresarMainDashboard}>
          <HomeIcon className="icon" /><p className="icon">Salir</p>
        </IconButton>
      </Tooltip>
      <Tooltip title="Firmar preventa">
        <IconButton onClick={() => executeWithProtection(handleArirModalFirmaPreVenta)} disabled={isProcessing}>
          <VerifiedIcon className="icon" /><p className="icon">Firmar</p>
        </IconButton>
      </Tooltip>
      <Tooltip title="Refrescar datos">
        <IconButton onClick={handleClickRefrescarDatosPreVenta}>
          <RefreshIcon className="icon" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Buscar artículos">
        <IconButton onClick={onBuscarArticulos}>
          <SearchIcon className="icon" /><p className="icon">Artículos</p>
        </IconButton>
      </Tooltip>
      <Tooltip title="Buscar clientes">
        <IconButton onClick={handleArirModalBuscarCliente}>
          <PersonSearchIcon className="icon" /><p className="icon">Clientes</p>
        </IconButton>
      </Tooltip>
      <Tooltip title="Otras acciones">
        <IconButton onClick={handleAbrirMenuModalPreventa}>
          <DensitySmallIcon className="icon" /><p className="icon">Menu</p>
        </IconButton>
      </Tooltip>
    </Fragment>
  );
}
